module.exports = __webpack_public_path__ + "img/delete-future.ed3b09c2.svg";